import { config, useSpring, useTrail } from '@react-spring/web'

import useMediaQuery from '@mui/material/useMediaQuery'

export const useReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)')

export const useFadeAnimation = (props = {}) =>
  useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: config.gentle,
    ...props,
  })

export const useStaggeredTrail = (itemCount, delay = 100) => {
  return useTrail(itemCount, {
    from: { opacity: 0, transform: 'translateY(30px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: config.gentle,
    delay,
  })
}
